module.exports = __webpack_public_path__ + "static/media/12_plantilla_qr_comida_3.2528a2a2.png";